import React, { useEffect, useState } from "react";
import svgPaths from "./svg-lw5tsgrsxy";
import imgImage521 from "../../../assets/web-v3-images/2b95eabc35cc72be0b91a0d1a96588f6c6943ed4.png";
import imgImage524 from "../../../assets/web-v3-images/41541279f77f5941922228030afb10c5748f4d5c.png";
import imgImage23 from "../../../assets/web-v3-images/5e5e45b17f66bb003c12985f2dc95d3eda61f82e.png";
import bgButton from "../../../assets/images/bg-button-pz.png";
import { useTranslation } from "react-i18next";
import Headers from "@/component/Headers";
import { useDispatch, useSelector } from "react-redux";
import { curDailyPrize, curStateHome } from "@/Redux/selector";
import {
  getBannerHome,
  getBidProduct,
  getUpNextProduct,
} from "@/Redux/futures/home/actions";
import { setIdCurrentProduct } from "@/Redux/futures/rightWeb/actions";
import { currentDate, IS_UPDATE_VERSION_3_PROJECT } from "@/helper/const";
import dayjs from "dayjs";
import PopupFrame from "@/component/popups/ui-1";
import { Text } from "@radix-ui/themes";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import { formatDataNumberToen } from '@/utils/helper';
import { getDailyPrizePrizePool } from '@/Redux/futures/daily-reward/actions';

SwiperCore.use([Autoplay]);

function ComponentButton({ isActive, text = "", fontSize = "text-[32px]" }) {
  return (
    <div
      className={`content-stretch flex items-center relative shrink-0 w-[407px] ${isActive ? "" : "opacity-60"}`}
    >
      <img alt="" src={bgButton} />
      <p className={`-translate-x-1/2 w-[max-content] [word-break:break-word] absolute font-['Inter:Extra_Bold',sans-serif] font-extrabold h-[36px] leading-[1.12] left-[calc(50%+0.5px)] not-italic text-[#fbf5da] ${fontSize} text-center top-[calc(50%-23.29px)] w-[250px]`}>
        {text}
      </p>
    </div>
  );
}

const ImageSwiper = ({ product }) => {
  const images = product
    ? product?.split(",").map(item => item?.trim())
    : [];

  return (
    <Swiper
      pagination={{ clickable: true }}
      spaceBetween={12}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      slidesPerView={1}
      className="h-full"
      clickable={(e) => e.stopPropagation()}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img
            src={image}
            alt={`product-${index}`}
            className="w-full h-full object-contain"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const Item = ({ item, handleClick, tab }) => {
  const { t } = useTranslation();
  return (
    <div className="content-stretch flex flex-col items-start relative size-full cursor-pointer" onClick={handleClick}>
      <div
        className="content-stretch drop-shadow-[0px_1px_1px_rgba(10,13,18,0.05)] flex flex-col gap-px isolate items-start overflow-clip relative rounded-[12px] shrink-0 w-full"
        data-name="Table"
      >
        <div className="relative shrink-0 w-full z-[1]" data-name="Table cell">
          <div aria-hidden className="absolute border-[#f7b27a] border-b-2 border-solid inset-0 pointer-events-none" />
          <div className="flex flex-row items-center size-full">
            <div className="content-stretch flex gap-[12px] items-center pr-[24px] py-[16px] relative size-full">
              <div className="h-[240px] relative shrink-0 w-[300px]" data-name="image 319">
                {/* <img alt="" className="absolute inset-0 max-w-none object-contain pointer-events-none size-full" src={imgImage319} /> */}
                <ImageSwiper product={item?.product_image} />
              </div>
              <div className="content-stretch flex flex-col gap-[20px] items-start justify-center relative shrink-0 w-[500px]">
                <p className="[word-break:break-word] font-['Inter:Bold',sans-serif] font-bold leading-[1] not-italic relative shrink-0 text-[#542314] text-[40px] w-full">
                  {item?.product_name || ""}
                </p>
                {tab === "weekly" &&
                  <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#9a5a3b] text-[28px] tracking-[0.28px] w-full">
                    {t("home_page.product_price").replace("_PRICE_", formatDataNumberToen(item?.product_price))}
                  </p>
                }
                <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#9a5a3b] text-[28px] tracking-[0.28px] w-full">{t("home_page.code").replace("_CODE_", item?.product_code || '')}</p>
                <div className="content-stretch flex items-start relative shrink-0 w-full">
                  <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#9a5a3b] text-[28px] tracking-[0.28px] w-[415px]">{t("start_date")}: {item?.start_time ? dayjs(item.start_time).format("DD/MM/YYYY HH:mm") : ""}</p>
                </div>
                <div className="content-stretch flex items-start relative shrink-0 w-full">
                  <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#9a5a3b] text-[28px] tracking-[0.28px] w-[415px]">{t("end_date")}: {item?.end_time ? dayjs(item.end_time).format("DD/MM/YYYY HH:mm") : ""}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function MainBody() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation()
  const [tab, setTab] = useState("weekly");
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const selectorHome = useSelector(curStateHome);
  const { dailyPrizePrizePool } = useSelector(curDailyPrize);
  const [upNextProduct, setUpNextProduct] = useState([]);

  useEffect(() => {
    if (selectorHome?.upNextProduct?.length > 0) {
      let newUpNextProduct = selectorHome.upNextProduct?.sort(
        (a, b) => Date.parse(a?.start_time) - Date.parse(b?.start_time),
      );
      setUpNextProduct(newUpNextProduct);
    } else {
      setUpNextProduct([]);
    }
  }, [selectorHome]);

  useEffect(() => {
    if (tab === "weekly") {
      dispatch(getUpNextProduct({}));
    } else if (tab === "daily") {
      dispatch(getDailyPrizePrizePool({}));
    }
  }, [tab]);

  return (
    <>
      <div className="absolute content-stretch flex flex-col items-start left-0 right-0 top-[254.29px]">
        <div className="relative shrink-0 w-full">
          <div className="flex flex-row items-center size-full">
            <div className="content-stretch flex gap-[16px] items-center px-[32px] relative size-full">
              <div onClick={() => setTab("weekly")} className="cursor-pointer">
                <ComponentButton
                  text={t("weekly_cycle")}
                  isActive={tab === "weekly"}
                  fontSize={i18n.language === "my" ? "text-[26px]" : "text-[32px]"}
                />
              </div>
              {IS_UPDATE_VERSION_3_PROJECT &&
                <div onClick={() => setTab("daily")} className="cursor-pointer">
                  <ComponentButton
                    text={t("daily_cycle")}
                    isActive={tab === "daily"}
                    fontSize={i18n.language === "my" ? "text-[26px]" : "text-[32px]"}
                  />
                </div>
              }
            </div>
          </div>
        </div>
        <div className="mt-3 content-start flex flex-wrap gap-[32px] items-start p-[32px] relative shrink-0 w-[880px] overflow-y-auto max-h-[1450px] scrollbar-thin scrollbar-thumb-[#E6B97D] scrollbar-track-transparent">
          {tab === "weekly" ?
            <>
              {upNextProduct?.length > 0 &&
                upNextProduct?.map((item, index) => {
                  return (
                    <Item
                      key={index}
                      item={item}
                      tab={tab}
                      handleClick={() => {
                        setOpen(true);
                        setSelectedItem(item);
                      }}
                    />
                  );
                })}
            </>
            :
            <>
              {dailyPrizePrizePool?.items?.length > 0 &&
                dailyPrizePrizePool?.items?.map((item, index) => {
                  let items = {
                    product_image: item?.image_url,
                    product_name: item?.name,
                    product_price: item?.product_price,
                    product_code: item?.product_code,
                    description: item?.reward_note,
                    start_time: dayjs(item?.date).startOf('day').toISOString(),
                    end_time: dayjs(item?.date).endOf('day').toISOString(),
                  }

                  return (
                    <Item
                      key={index}
                      item={items}
                      tab={tab}
                      // handleClick={() => {
                      //   setOpen(true);
                      //   setSelectedItem(items);
                      // }}
                    />
                  );
                })}
            </>}
        </div>
      </div>
      <PopupFrame
        title={t("prize_pool.prize_information")}
        open={open}
        onOpenChange={setOpen}
      >
        <div className="">
          <p
            className="
            bg-[rgba(253,234,215,1)]
            text-[rgba(113,59,18,1)]
            font-bold
            text-center
            rounded-2xl sm:rounded-3xl
            py-2 px-2 sm:py-2 sm:px-3
            text-lg sm:text-xl md:text-2xl
            mb-2
          "
          >
            {selectedItem?.product_name || ""}
          </p>
          <div className='flex justify-center w-full h-[300px]'>
            <ImageSwiper product={selectedItem?.product_image} />
          </div>
          {selectedItem?.description &&
            <Text
              as="div"
              className="
            bg-[rgba(254,246,238,1)]
            rounded-xl
            p-3 sm:p-4 md:p-5
            text-[rgba(133,74,14,1)]
            font-medium
            text-sm sm:text-base md:text-lg
            break-words
            !mt-2
          "
            >
              {selectedItem?.description || ""}
            </Text>
          }
        </div>
      </PopupFrame>
    </>
  );
}

function Header() {
  const { t } = useTranslation();
  return (
    <Headers
      title={t("home.hero.prizePool")}
      className="absolute left-0 top-[110.29px] w-[880px] gap-[24px] px-[32px] py-[24px]"
    />
  );
}

export default function ComponentPrizePool() {


  return (
    <div
      className="relative size-full"
      style={{
        // backgroundImage:
        //   "linear-gradient(rgb(252, 238, 210) 0%, rgb(253, 210, 156) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
      }}
      data-name="Prize Pool"
    >
      <div
        className="-translate-x-1/2 absolute h-[520px] left-1/2 top-[-135px] w-[924px]"
        data-name="image 521"
      >
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <img
            alt=""
            className="absolute max-w-none object-cover size-full -mt-1"
            src={imgImage521}
          />
          <div className="absolute bg-gradient-to-b from-[65.577%] from-[rgba(252,232,199,0)] inset-0 to-[#fce8c7] to-[97.788%]" />
        </div>
      </div>
      <div className="mt-[-30px] sm:mt-[-65px]">
        <div className="-translate-x-1/2 absolute left-1/2 top-0 w-[880px]">
          <Header />
          <MainBody />
        </div>
      </div>
    </div>
  );
}
